import { IconMainMenuCLI } from "@suse-o11y/icons";
import React from "react";

import { BREADCRUMB_ICON_CLASS } from "../../../components/react/icon/Icon";
import { useNavigateToLink } from "../../../components/react/link";
import { CLIPROFILE_PATH } from "../../Routes";
import { BreadcrumbLayout } from "../BreadcrumbLayout";

export const CLIProfileBreadcrumb = () => {
	const link = useNavigateToLink(CLIPROFILE_PATH, {
		search: ["timeRange", "timestamp", "detachedFilters"],
	});

	return <BreadcrumbLayout icon={<IconMainMenuCLI className={BREADCRUMB_ICON_CLASS} />} label="CLI" to={link} />;
};

CLIProfileBreadcrumb.PATH = CLIPROFILE_PATH;
